import Vue from 'vue';
import Router from 'vue-router';
import PrivacyPage from '@/pages/PrivacyPage';
import HomeComponent from '@/pages/HomeComponent';
import Introduction from '@/pages/Introduction';
import ExplorePage from '@/pages/ExplorePage';
import ServePage from '@/pages/ServePage';
import CooperationPage from '@/pages/CooperationPage';
import DisplayPage from '@/pages/DisplayPage';



const routes = [
    {
        path: '/',
        name: 'HomeComponent',
        component: HomeComponent
    },
    {
        path: '/HomeComponent',
        name: 'HomeComponent',
        component: HomeComponent
    },
    {
        path: '/PrivacyPage',
        name: 'PrivacyPage',
        component: PrivacyPage
    }
    ,
    {
        path: '/Introduction',
        name: 'Introduction',
        component: Introduction
    },
    {
        path: '/ExplorePage',
        name: 'ExplorePage',
        component: ExplorePage
    },
    {
        path: '/ServePage',
        name: 'ServePage',
        component: ServePage
    },
    {
        path: '/CooperationPage',
        name: 'CooperationPage',
        component: CooperationPage
    },
    {
        path: '/DisplayPage',
        name: 'DisplayPage',
        component: DisplayPage
    }
]

Vue.use(Router);
export default new Router({
  routes: routes
});

